<p-dialog
  [(visible)]="showDialog"
  (onHide)="closeDialog.emit()"
  [header]="header ? header : (translationKeys.dossierErrorDetailsDialogComponent.html.dossierErrorDialogTitle | translate)"
  [modal]="true"
  appendTo="body"
  [style]="{ width: '40vw' }"
>
  <avano-panel [headerText]="translationKeys.dossierErrorDetailsDialogComponent.html.errorHeader | translate">
    {{ errorDescription ? errorDescription : (translationKeys.dossierErrorDetailsDialogComponent.html.errorParsingFallback | translate) }}
    <br />
    <br />
    {{ translationKeys.dossierErrorDetailsDialogComponent.html.contactSupport | translate }}
  </avano-panel>

  <avano-more-less-information
    [headerText]="translationKeys.dossierErrorDetailsDialogComponent.html.technicalDetails | translate"
    [collapsed]="!!errorDescription"
  >
    {{ unconvertedDossierError.echaResponseStatus }}<br /><br />
    {{ unconvertedDossierError.echaResponseErrorText }}
  </avano-more-less-information>

  <ng-template pTemplate="footer">
    <button
      type="button"
      avanoButton
      [callToAction]="true"
      [label]="translationKeys.commonTranslationKey.btn.close | translate"
      icon="icon-content-check"
      (click)="closeDialog.emit()"
    ></button>
  </ng-template>
</p-dialog>
